var map = {
	"./book-s.png": 1067,
	"./book.png": 316,
	"./class-s.png": 1068,
	"./class.png": 317,
	"./coin-s.png": 1069,
	"./coin.png": 1070,
	"./donation-s.png": 1071,
	"./donation.png": 1072,
	"./invite-s.png": 1073,
	"./invite.png": 1074,
	"./money-s.png": 1075,
	"./money.png": 1076,
	"./reading-off.png": 1077,
	"./reading-s.png": 1078,
	"./reading.png": 1079,
	"./reviews.png": 1080,
	"./school-s.png": 1081,
	"./school.png": 1082,
	"./student-s.png": 1083,
	"./student.png": 1084,
	"./writing-s.png": 1085,
	"./writing.png": 1086
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;



//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons .\.png*
// module id = 369
// module chunks = 0